
import { computed, defineComponent, ref } from 'vue'
import { useStore } from '@/store'
import Hamburger from '_c/Hamburger/index.vue'
import Breadcrumb from '_c/Breadcrumb/index.vue'
import { clearAll } from '../../../utils/storage'
import { ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'Navbar',
  components: { Hamburger, Breadcrumb },
  setup () {
    const store = useStore()
    const router = useRouter();
    const sidebar = computed(() => store.state.app.sidebar)

    const userAvatar = computed(() => store.state.user.user.avatar)

    const userAccount = computed(() => store.state.user.user.account)

    const toggleSideBar = () => {
      store.dispatch('app/toggleSideBar')
    }

    const loginout = () => {
      ElMessageBox.confirm('是否确认退出当前登录', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearAll()
        router.replace('login')
        location.reload();
      })
    }

    const dropdownShow = ref<boolean>(false)
    const visibleChange = (show: boolean) => {
      dropdownShow.value = show
    }

    const onHandleCommandClick = (path: string) => {
      if(path == 'loginout'){
        loginout()
      }
    }


    return {
      sidebar,
      userAvatar,
      userAccount,
      toggleSideBar,
      loginout,
      dropdownShow,
      visibleChange,
      onHandleCommandClick
    }
  }
})
